import user from './user'
import login from './login'
import registration from './registration'
import tenantRegistration from './tenant-registration'
import emailVerification from './emailVerification'
import confirmPassword from './confirmPassword'
import password from './password'
import profileInformation from './profileInformation'
import twoFactorAuthentication from './twoFactorAuthentication'
import otherBrowserSessions from './otherBrowserSessions'
import activeLoginProviders from './activeLoginProviders'
import loginProviders from './loginProviders'

export default {
	namespaced: true,
	modules: {
		user,
		login,
		registration,
		tenantRegistration,
		emailVerification,
		confirmPassword,
		password,
		profileInformation,
		twoFactorAuthentication,
		otherBrowserSessions,
		activeLoginProviders,
		loginProviders
	}
}